<div class="bg-img-enroll">
  <main class="container">
    @if (model) {
      <div class="line-bg">
        <div class="d-lg-flex justify-content-between align-items-start">
          <div class="title text-uppercase" data-cy="step-title">
            {{ model.title }}
            <div class="seperator mt-3 d-block"></div>
          </div>
          <div class="mt-2">
            <button type="button" class="btn btn-outline-secondary px-5" (click)="openExitModal()" data-cy="exit-btn">Exit</button>
          </div>
        </div>
        <div class="enroll-contain">
          <app-step-wrapper [model]="model">
            <ng-content></ng-content>
          </app-step-wrapper>
        </div>
      </div>
    } @else {
      <div class="mx-auto loader-yellow centered"></div>
    }
  </main>
</div>

<app-modal size="small" #exitModal>
  <div class="modal-content" data-cy="exit-modal">
    <div class="modal-header">
      <h5 class="modal-title title" data-cy="exit-modal-title">Are you sure you want to exit?</h5>
    </div>
    <div class="modal-body" data-cy="exit-modal-body">Any unsaved data for this page will be lost.</div>
    <div class="modal-footer">
      <button type="button" class="btn btn-outline-secondary px-5" (click)="exitModal.close()" data-cy="exit-no-btn">No</button>
      <button type="button" class="btn btn-primary px-5 ml-lg-5" (click)="navigateToHome()" data-cy="exit-yes-btn">Yes</button>
    </div>
  </div>
</app-modal>
